module.exports = __webpack_public_path__ + "img/after-sales.6dd3647e.png";